<template>
  <div class="header">
    <div class="header-body">
      <div class="row">
        <div class="col">
          <h6 v-if="pretitle" class="header-pretitle">{{ pretitle }}</h6>
          <h1 class="header-title">{{ title }}</h1>
        </div>
        <div class="col-auto">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    pretitle: { type: String, default: null },
    title: { type: String, default: null },
  }
}
</script>
